import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  Typography,
  TextField,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Checkbox,
} from "@mui/material";

const MatchResultModal = ({ open, handleClose, handleSubmit, matchData }) => {
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    if (matchData?.participants) {
      setFormData(
        matchData.participants.map((p) => ({
          name: p.name,
          id: p.id,
          points: "",
          isWinner: false,
        }))
      );
    }
  }, [matchData]);

  const handleChange = (index, field, value) => {
    setFormData((prevState) => {
      const updatedData = [...prevState];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return updatedData;
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Enter Match Result</Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Participant</TableCell>
                  <TableCell>Points</TableCell>
                  <TableCell>IsWinner</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {matchData.participants &&
                  matchData.participants.length > 0 &&
                  matchData.participants.map((row, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell>
                        <Typography>{row.name}</Typography>
                      </TableCell>
                      <TableCell>
                        <TextField
                          id={`points-${index}`}
                          label="Points"
                          name="points"
                          variant="outlined"
                          type="number"
                          fullWidth
                          value={formData[index]?.points || ""}
                          onChange={(e) =>
                            handleChange(index, "points", e.target.value)
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <FormControl>
                          <Checkbox
                            id={`isWinner-${index}`}
                            name="isWinner"
                            checked={formData[index]?.isWinner || false}
                            onChange={(e) =>
                              handleChange(index, "isWinner", e.target.checked)
                            }
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Close Match
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MatchResultModal;
